




import Vue from "vue";
import Chart from "chart.js";

const formatNumber = value => {
  if (value === 0) return 0;
  if (!value) return;
  value += "";
  let x = value.split(".");
  let x1 = x[0];
  let x2 = x.length > 1 ? "." + x[1] : "";
  let rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, "$1" + "," + "$2");
  }
  return x1 + x2;
};

export default Vue.extend({
  name: "ColumnChart",
  props: ["payload"],
  data: () => ({
    chartId: Math.random()
      .toString()
      .substr(3, 17)
  }),
  methods: {
    chartInit(datasets, labels, title, unit) {
      const ctx = (document as any)
        .getElementById(this.chartId)
        .getContext("2d");
      const options = {
        responsive: true,
        title: {
          display: true,
          text: title
        },
        tooltips: {
          callbacks: {
            label: item => `${formatNumber(item.yLabel)} ${unit}`
          }
        },
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: `${unit}`
              },
              ticks: {
                callback: function(item) {
                  return formatNumber(item);
                }
              }
            }
          ],
          xAxes: [
            {
              gridLines: {
                offsetGridLines: true
              }
            }
          ]
        }
      };

      const myLineChart = new Chart(ctx, {
        type: "bar",
        data: {
          datasets,
          labels
        },
        options: options
      });
    }
  },
  mounted() {
    let datasets: any[] = [];
    const labels = this.payload.data.map(x => x.xLabel);

    const dataColArray = this.payload.data.map(x => x.colValues);
    const datasetsColLabel = this.payload.colLabels as string[];
    const colorColArray = this.payload.colColors as string[];

    datasetsColLabel.forEach((x, index) => {
      const datasetsCol: { [key: string]: any } = {};
      datasetsCol.label = x;
      const newData = dataColArray.map(y => y[index]);
      const newColor = colorColArray[index];
      datasetsCol.data = newData;
      datasetsCol.backgroundColor = newColor;
      datasets.push(datasetsCol);
    });

    this.chartInit(datasets, labels, this.payload.title, this.payload.unit);
  }
});
